import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import ReportService from '../../service/report-service';
import SimpleReport from './simple-report';
import DetailedReport from './detailed-report';
import DiagnosticReport from './diagnostic-report';

import Header from '../template/header'
import Footer from '../template/footer'
import { ModalAlert } from '../template/modal-alert';

import i18n from "../../i18n";

export default class Report extends Component {

	constructor(props) {
		super(props);
		this.state = {
			reportType: null,
			simpleReport: null,
			detailedReport: null,
			diagnosticReport: null,
			reportId: null,
			hash: null,
			linkId: null,
			documentName: null,
			reportGenerationTime: null,
			permLinkValidUntil: null,
			serialNumbers: null
		}

		var url = window.location.href;
		var splittedUrl = url.split("/");

		if (splittedUrl[splittedUrl.length - 1] == "phone") {
			this.state.phone = true;
			var hash = splittedUrl[splittedUrl.length - 4];
			var linkId = splittedUrl[splittedUrl.length - 3];
			var lang = splittedUrl[splittedUrl.length - 2];
		} else {
			this.state.phone = false;
			var hash = splittedUrl[splittedUrl.length - 3];
			var linkId = splittedUrl[splittedUrl.length - 2];
			var lang = splittedUrl[splittedUrl.length - 1];
		}

		if (lang == 1) {
			i18n.changeLanguage("hr");
			document.getElementsByTagName("html")[0].setAttribute("lang", "hr")
		} else if (lang == 2) {
			i18n.changeLanguage("en");
			document.getElementsByTagName("html")[0].setAttribute("lang", "en")
		}

		ReportService.getPermReport(hash, linkId, lang).then(response => {
			this.setState({
				reportType: response.data.responseType,
				simpleReport: response.data.permReports.simpleReport,
				detailedReport: response.data.permReports.detailedReport,
				diagnosticReport: response.data.permReports.diagnosticData,
				reportId: response.data.permReports.reportId,
				documentName: response.data.permReports.documentName,
				reportGenerationTime: response.data.permReports.reportGenerationDate,
				permLinkValidUntil: response.data.permReports.permLinkValidDate,
				serialNumbers: response.data.serialNumbers,
				hash: hash,
				linkId: linkId,
				language: lang
			});
		}
		).catch(error => {
			if (error.response == null) {
				ModalAlert("Došlo je do greške prilikom prikaza izvještaja. Molimo Vas pokušajte ponovno.", i18n.t("modal:greska"), i18n.t("modal:zatvori"));
			} else {
				ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
			}
		});

	}

	handleKeyUp = (event) => {
		if (event.keyCode === 13) {
			event.preventDefault();
			event.currentTarget.click();
		}
	}

	render() {
		//console.log(this.state);
		return (
			<React.Fragment>
				<GetType data={this.state} handleKeyUp={this.handleKeyUp} />
			</React.Fragment>
		)
	}
}

function GetType(props) {
	const reportType = props.data.reportType;
	if (reportType == 0) {
		return (
			<main>
				{!props.data.phone ?
					<React.Fragment>
						<Header />
						<br /><br /><br /><br /><br />
					</React.Fragment>
					:
					<React.Fragment>
						<br />
					</React.Fragment>
				}
				<SimpleReport report={props.data.simpleReport} reportId={props.data.reportId} documentName={props.data.documentName}
					reportGenerationTime={props.data.reportGenerationTime} permLinkValidUntil={props.data.permLinkValidUntil}
					hash={props.data.hash} linkId={props.data.linkId} language={props.data.language} handleKeyUp={props.handleKeyUp} />
				<br /><br />
				<Footer />
			</main>
		);
	} else if (reportType == 1) {
		return (
			<main>
				{!props.data.phone ?
					<React.Fragment>
						<Header />
						<br /><br /><br /><br /><br />
					</React.Fragment>
					:
					<React.Fragment>
						<br />
					</React.Fragment>
				}
				<DetailedReport report={props.data.detailedReport} reportId={props.data.reportId} documentName={props.data.documentName}
					reportGenerationTime={props.data.reportGenerationTime} permLinkValidUntil={props.data.permLinkValidUntil}
					hash={props.data.hash} linkId={props.data.linkId} language={props.data.language} handleKeyUp={props.handleKeyUp} />
				<br /><br />
				<Footer />
			</main>
		);
	} else if (reportType == 2) {
		return (
			<main>
				{!props.data.phone ?
					<React.Fragment>
						<Header />
						<br /><br /><br /><br /><br />
					</React.Fragment>
					:
					<React.Fragment>
						<br />
					</React.Fragment>
				}
				<DiagnosticReport report={props.data.diagnosticReport} reportId={props.data.reportId} documentName={props.data.documentName}
					reportGenerationTime={props.data.reportGenerationTime} permLinkValidUntil={props.data.permLinkValidUntil} serialNumbers={props.data.serialNumbers}
					hash={props.data.hash} linkId={props.data.linkId} language={props.data.language} handleKeyUp={props.handleKeyUp} />
				<br /><br />
				<Footer />
			</main>
		);
	} else {
		return null;
	}
}